export default __webpack_public_path__ + "static/layout-do-light-8161e2358529c72a9b575c667fd50fb3.png";